import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Avatar, Paper, Chip, Alert, Typography } from "@mui/material";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import { Dialog, DialogContent, Box, Tooltip } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Link from "next/link";
import { Button } from "react-bootstrap";
import ClearIcon from "@mui/icons-material/Clear";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import * as constants from "../../Components/constants";
import { useDropzone } from "react-dropzone";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import Image from "next/image";
import InlineTextEditor from "../../Components/TextEditor/InlineTextEditor";

const DraftAlert = React.forwardRef(function DraftAlert(props, ref) {
  return <MuiAlert elevation={3} ref={ref} variant="filled" {...props} />;
});

const BASE_URL = constants.BASE_URL;

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: "auto",
  height: 120,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};
const drop = {
  borderStyle: "dotted",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

const GroupPostBar = ({
  groupID,
  singleGroup,
  handleSingleGroupPost,
  groupOwner,
}) => {
  const [description, setDescription] = React.useState("");
  const [darfText, setDarfText] = React.useState("");
  const [openSuc, setOpenSuc] = React.useState(false);

  // const [postFile, setPostFile] = React.useState("");
  const [isUpload, setIsUpload] = React.useState(false);
  const [uploaded, setUploaded] = React.useState(null);
  const [alert, setAlert] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");

  const handleCloseSuc = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuc(false);
  };

  // Image upload system

  const [files, setFiles] = React.useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
      "video/*": [],
    },
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      {file && (
        <div style={thumbInner}>
          {/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(file.name) ? (
            <Image
              height={200}
              width={200}
              objectFit="contain"
              src={file.preview}
              alt="uploaded"
              title="uploaded"
              onLoad={() => {
                URL.revokeObjectURL(file.preview);
                setIsUpload(false);
              }}
            />
          ) : (
            <video controls muted>
              <source src={file.preview} type="video/mp4" />
            </video>
          )}
        </div>
      )}
    </div>
  ));

  React.useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);

  // group thought post

  function handleGroupThoughtPost() {
    setIsUpload(false);
    const newData = new FormData();
    newData.append("description", description);
    newData.append("group", groupID);
    newData.append("pic_upload", files[0] ? files[0] : "");
    if (description === "") {
      setAlert(true);
    } else {
      axios
        .request({
          method: "post",
          url: `${BASE_URL}/post/${groupID}/group-thought-create/`,
          data: newData,
          headers: {
            Authorization: `Token ${localStorage.getItem("auth_token")}`,
          },
          onUploadProgress: (p) => {
            setUploaded(Math.round((p.loaded / p.total) * 100));
          },
        })
        .then((res) => {
          setDescription("");
          if (res.status === 400) {
            alert("please enter all the required field");
          } else if (res.status === 201) {
            setUploaded(null);
            setFiles([]);
            setOpen(false);
            setDescription("");
            localStorage.setItem("description", "");
            handleSingleGroupPost();
          }
        });
    }
  }

  function saveText() {
    localStorage.setItem("description", description);
    setOpenSuc(true);
  }

  React.useEffect(() => {
    const savedText = localStorage.getItem("description");
    setDarfText(savedText);
  }, [description, saveText]);

  return (
    <>
      <Row className="justify-content-center">
        <Col md={12}>
          <Paper className="p-3 rounded-4">
            <div className="d-flex align-items-center">
              <Avatar
                className="border"
                alt="Remy Sharp"
                src={singleGroup.profile_pic}
                sx={{ width: 60, height: 60 }}
              />
              <Form.Control
                onClick={handleOpen}
                className="rounded-pill mx-2 p-2"
                type="text"
                placeholder="Start a post"
              />
            </div>

            <div className="text-end mt-2 me-2">
              {groupOwner.role === "Creator" && (
                <Link href={`/course/create/${groupID}`}>
                  <Chip
                    className="mx-1"
                    style={{ cursor: "pointer" }}
                    icon={<PostAddRoundedIcon />}
                    label="Create Course"
                    color="primary"
                    variant="outlined"
                  />
                </Link>
              )}

              <Link
                href={{
                  pathname: `/post/summary`,
                  query: {
                    keyword: `${groupID}`,
                  },
                }}
              >
                <Chip
                  style={{ cursor: "pointer" }}
                  icon={<PostAddRoundedIcon />}
                  label="Research Summary"
                  color="primary"
                  variant="outlined"
                />
              </Link>
            </div>
          </Paper>
        </Col>

        <>
          <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
          >
            <DialogContent>
              <div className="d-flex align-items-center">
                <Avatar
                  className="border"
                  alt="groupProfile"
                  src={singleGroup.profile_pic}
                  sx={{ width: 50, height: 50 }}
                />
                <span className="mx-2 fw-bold">{singleGroup?.name}</span>
              </div>

              <Box className="my-2">
                <h6 className="py-2">What do you want to research post?</h6>
                <div className="border p-2">
                  <InlineTextEditor
                    value={darfText}
                    onChange={(event, editor) => {
                      setDescription(event);
                    }}
                  />

                  {isUpload && (
                    <section className="text-center">
                      <div
                        {...getRootProps({ className: "dropzone mt-2" })}
                        style={drop}
                      >
                        <input {...getInputProps()} />
                        <div className="d-flex justify-content-end p-1">
                          <Avatar
                            onClick={() => setIsUpload(false)}
                            sx={{
                              bgcolor: "text.disabled",
                              width: 24,
                              height: 24,
                            }}
                          >
                            <ClearIcon style={{ fontSize: "16px" }} />
                          </Avatar>
                        </div>
                        <Box
                          sx={{
                            py: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Avatar sx={{ bgcolor: "text.disabled" }}>
                            <LibraryAddIcon />
                          </Avatar>
                          <Typography variant="overline">
                            Add photos / videos
                          </Typography>
                          <Typography variant="caption">
                            or drag and drop
                          </Typography>
                        </Box>
                      </div>
                    </section>
                  )}
                  <div className="d-flex justify-content-center">
                    <aside style={thumbsContainer}>{thumbs}</aside>
                  </div>
                </div>

                {alert && (
                  <Alert
                    severity="error"
                    onCick={setTimeout(function () {
                      setAlert(false);
                    }, 3000)}
                  >
                    Please add something and try again!
                  </Alert>
                )}
                {uploaded && (
                  <div className="progress mt-2">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow={uploaded}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: `${uploaded}%` }}
                    >
                      {`${uploaded}%`}
                    </div>
                  </div>
                )}
              </Box>

              <div className="d-flex justify-content-between flex-wrap align-items-center px-2">
                <h6>Add to you post</h6>
                <Box
                  onClick={() => setIsUpload(true)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Avatar sx={{ bgcolor: "success.main" }}>
                    <UploadFileIcon />
                  </Avatar>
                </Box>
              </div>

              <div className="d-flex justify-content-between pt-3">
                <Tooltip title="You can save you post in draft" arrow>
                  <Button variant="secondary" size="sm" onClick={saveText}>
                    Save as Draft
                  </Button>
                </Tooltip>

                <Button
                  onClick={() => {
                    handleGroupThoughtPost();
                  }}
                  variant="primary"
                  size="sm"
                >
                  Publish
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </>
      </Row>

      <Snackbar open={openSuc} autoHideDuration={5000} onClose={handleCloseSuc}>
        <DraftAlert
          onClose={handleCloseSuc}
          severity="success"
          sx={{ width: "100%" }}
        >
          Save as a Darft
        </DraftAlert>
      </Snackbar>
    </>
  );
};

export default GroupPostBar;
